import BithidePaymentInfoPending from './BithidePaymentInfoPending';
export default BithidePaymentInfoPending;
